import type { Destination } from "@whatslly/types/messages-server/destinations";

// Single source of truth for destination display names, keyed by destination `type`.
// Used by platform's DestinationList and by server-side alerts so names don't drift.
export const DESTINATION_NAMES: Record<Destination["type"], string> = {
  pipedrive: "Pipedrive",
  hubspot: "Hubspot",
  openai: "OpenAI",
  anthropic: "Anthropic",
  google: "Google AI",
  azure_openai: "Azure OpenAI",
  bedrock: "Amazon Bedrock",
  internalAzureOpenAi: "Internal Azure OpenAI",
  azureSpeechTranscribe: "Azure AI Speech",
  amazonTranscribe: "Amazon Transcribe",
  googleSecOpsAuditLog: "Google SecOps",
  googleSecOpsDlpIncident: "Google SecOps",
  splunkAuditLog: "Splunk",
  splunkDlpIncident: "Splunk",
  elasticAuditLog: "Elastic",
  elasticDlpIncident: "Elastic",
  salesforce: "Salesforce",
  salesforceDataCloud: "Salesforce Data Cloud",
  dynamics: "Microsoft Dynamics",
  crowdstrike: "CrowdStrike SIEM",
  crowdstrikeAuditLog: "CrowdStrike SIEM",
  crowdstrikeDlpIncident: "CrowdStrike SIEM",
  splunk: "Splunk",
  coralogix: "Coralogix",
  smtp: "Global Relay",
  forcepointDlpDetector: "Forcepoint",
  microsoftPurviewDlpDetector: "Microsoft Purview",
  proofpoint: "Proofpoint",
  customS3: "Amazon S3",
  r2: "Cloudflare R2",
  sftp: "SFTP",
  internalS3: "Internal Amazon S3",
  azureBlob: "Azure Storage",
  verint: "Verint",
  googleCloudStorage: "Google Cloud Storage",
  qradar: "QRadar",
  qradarAuditLog: "QRadar",
  qradarDlpIncident: "QRadar",
  sentinelDlpIncident: "Microsoft Sentinel",
  paloAltoFirewall: "Palo Alto",
  checkpointFirewall: "Check Point",
  sentinelOneFirewall: "Sentinel One",
  skyhighProxy: "Skyhigh",
  netskopeCasbProxy: "Netskope (CASB)",
  crowdStrikeEndpointProtection: "CrowdStrike",
  broadcomProxySg: "Broadcom (Symantec ProxySG)",
  forcepointProxyWebSecurity: "Forcepoint (Proxy WebSecurity)",
  fortinetFortigateProxy: "Fortinet (Fortigate)",
  trellixProxy: "Trellix",
  trendMicroEeEndpointProtection: "Trend Micro (Ee)",
  kasperskyEndpoint: "Kaspersky",
  zscalerProxy: "Zscaler",
  sonicWallFirewall: "SonicWall",
  ciscoFirewall: "Cisco",
  microsoftDefenderEndpoint: "Microsoft Defender",
  carbonBlackEndpoint: "Carbon Black",
  sophosFirewall: "Sophos",
  other: "Other",
  virusTotalFileScan: "VirusTotal",
  // Internal Tuvis-owned destinations (not shown in platform's picker).
  s3: "Tuvis S3",
  analytics: "Analytics",
  urlAnalytics: "URL Analytics",
  batch: "Batch",
  tuvisDLP: "Tuvis DLP",
  tuvisKeywordInsights: "Tuvis Keyword Insights",
  tuvisSurveillance: "Tuvis Surveillance",
  tuvisBlockedPhones: "Tuvis Blocked Phones",
};
